import type * as PIXI from 'pixi.js';
import type { Viewport } from 'pixi-viewport';

// A freshly bought / placed item should be impossible to miss. Small things (a
// phone, a cup) are only a few pixels tall at the room-overview zoom, so their
// selection outline reads as a dot; bring the camera close enough that the item
// is at least this tall on screen. Never zooms OUT.
const MIN_ITEM_SCREEN_PX = 140;
// Same ceiling as the room viewport's clampZoom (useRoomScene).
const MAX_FOCUS_SCALE = 3;
const FOCUS_ANIMATION_MS = 650;

export function focusCameraOnItem(viewport: Viewport | null, marker: PIXI.Container): void {
  if (!viewport) return;
  const bounds = marker.getBounds();
  if (bounds.width <= 0 || bounds.height <= 0) return;
  const center = viewport.toWorld(bounds.x + bounds.width / 2, bounds.y + bounds.height / 2);
  const worldHeight = bounds.height / viewport.scale.y;
  const neededScale = MIN_ITEM_SCREEN_PX / Math.max(1, worldHeight);
  const scale = Math.min(MAX_FOCUS_SCALE, Math.max(viewport.scale.y, neededScale));
  viewport.animate({
    position: center,
    scale,
    time: FOCUS_ANIMATION_MS,
    ease: 'easeInOutSine',
    removeOnInterrupt: true,
  });
}
